import { useEffect, useState } from "react";
import { useStores } from "../..";

let SESSION_TIMEOUT = 5 * 60 * 1000;
let SESSION_UPDATE_TIME_DEVIATION = 1 * 60 * 1000;
let MAX_USER_IDLE_TIME = 1 * 60 * 1000;

let useAuthCheck = (lastRequestTime: number) => {
  let appStore = useStores();
  const [lastActive, setLastActive] = useState(Date.now());

  // Remembers the last time of user activity (mouse movements and keydowns)
  useEffect(() => {
    let handleActivity = () => {
      setLastActive(Date.now());
    };
    appStore.authStore.checkAuthAsync();
    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);

    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
    };
  }, []);

  // Effect for re-update auth session
  useEffect(() => {
    console.log("Session use effect");

    let isUserInactiveForLongTime = () => {
      let now = Date.now();
      return now - lastActive > MAX_USER_IDLE_TIME;
    };

    let sessionUpdate = (update: () => void, logout: () => void) => {
      if (appStore.authStore.isAuth && !isUserInactiveForLongTime()) update();
      else logout();
    };

    let logout = () => {
      // TODO: logout
    };

    let newTimeoutId: NodeJS.Timeout | undefined = undefined;
    if (appStore.authStore.isAuth)
      newTimeoutId = setTimeout(() => {
        sessionUpdate(appStore.authStore.checkAuthAsync, logout);
      }, SESSION_TIMEOUT - SESSION_UPDATE_TIME_DEVIATION);

    return () => {
      clearTimeout(newTimeoutId);
    };
  }, [lastRequestTime, appStore.authStore.isAuth]);
};

export default useAuthCheck;
